import { FC } from 'react';
import { ButtonProps } from './button.type';

const Button: FC<ButtonProps> = (props) => {
  return (
    <button
      className={`${props.className} ${
        props.disabled
          ? 'bg-THEME_DISABLE_COLOR text-THEME_DISABLE_TEXT_COLOR cursor-not-allowed text-base'
          : 'bg-THEME_COLOR text-TEXT_COLOR hover:bg-THEME_HOVER_COLOR hover:text-TEXT_COLOR text-base'
      }`}
      onClick={props.onClick}
      disabled={props.disabled}
      style={props.style}
    >
      {props.children}
    </button>
  );
};

export default Button;
